const accordionButtons = document.getElementsByClassName("fp-footer__accordion");

for (let i = 0; i < accordionButtons.length; i++) {
  accordionButtons[i].addEventListener("click", (event) => {
    const { id } = event.currentTarget;
    const listId = `${id.split("heading")[0]}links`;
    const iconId = `${id.split("heading")[0]}accordion-icon`;

    const linkList = document.getElementById(listId);
    const iconSpan = document.getElementById(iconId);

    if (linkList.classList.contains("hidden")) {
      linkList.classList.remove("hidden");
      iconSpan.classList.remove("fp-footer__accordion-closed");
    } else {
      linkList.classList.add("hidden");
      iconSpan.classList.add("fp-footer__accordion-closed");
    }
  });
}
